'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFeedback = function ActionFeedback(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z' })
  );
};
ActionFeedback = (0, _pure2.default)(ActionFeedback);
ActionFeedback.displayName = 'ActionFeedback';
ActionFeedback.muiName = 'SvgIcon';

exports.default = ActionFeedback;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/feedback.js
// module id = 2520
// module chunks = 0